export default "__VITE_ASSET__6ZrQ8jKv__"